import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import cx from 'classnames'

import { Picture } from 'components/Picture'
import type { ImageType, PictureProps } from 'components/Picture/Picture.types'
import images from 'config/images.json'
import FavoriteButton from 'containers/FavoriteButton'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

type Props = {
  className?: string
  imagePath: string
  imageType: ImageType
  gameProduct: GameProduct
  dataTestId?: string
  isGameDescription?: boolean
}
function GameInfoMedia(props: Props) {
  const { gameProduct, className, imagePath, imageType, dataTestId, isGameDescription } = props
  const { isDarkMode } = useThemeContext()

  const pictureProps: PictureProps = {
    src: `${images.bucket}/${imagePath}/${gameProduct.code}/source.jpg`,
    alt: 'slot game',
    type: imageType,
    className: isGameDescription && classes.headerImage,
  }

  return (
    <div className={cx(classes['media-container'], className)} data-testid={dataTestId}>
      {isGameDescription && (
        <FavoriteButton
          className={cx(classes.descriptionFavorite, isDarkMode && classes.dark)}
          gameProduct={gameProduct}
          refererPath='game_description'
        />
      )}
      <Picture {...pictureProps} />
    </div>
  )
}

export default GameInfoMedia
